/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import { allRegisteredTrainingsExport } from "actions";
import RegisteredEmployee from "components/widgets/training/RegisteredEmployee";
import Pagination from "react-js-pagination";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import { Trans } from "react-i18next";
import i18next from "i18next";
import Helpers from "util/helpers";

class RegisteredEmployees extends Component {
  state = {
    filteredTrainingsData: [],
    filterTerm: "",
    error: null,
    activePage: 1,
    dataFetched: false,
    sort_by: "trTraining",
    sort_dir: "desc",
  };

  settings = {
    itemsPerPage: 10,
  };

  componentDidMount() {
    this.setState({
      filteredTrainingsData: this.props.data.registeredTrainings,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      this.setState({
        filteredTrainingsData: this.props.data.registeredTrainings,
      });
    }

    if (this.state.filterTerm !== prevState.filterTerm) {

      this.setState({
        filteredTrainingsData: this.props.data.registeredTrainings.filter(
          (item) => {
            return (
              Helpers
                .getTurkishCharaterFixedList(item.training.name)
                .includes(
                  Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
                ) ||
              Helpers
                .getTurkishCharaterFixedList(item.employee.name)
                .includes(
                  Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
                )
            );
          }
        ),
      });
    }
  }

  handlePageChange = (pageNum) => {
    this.setState({ activePage: pageNum });
  };

  handleFilter = (e) => {
    this.setState({ filterTerm: e.target.value });
  };

  handleExport = () => {
    this.props.allRegisteredTrainingsExport(
      this.onBegin,
      this.onExportSuccess,
      this.onError
    );
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    console.log(err);
    this.props.onProcessEnd();
  };

  onExportSuccess = (res, fname) => {
    this.props.onProcessEnd();
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fname);
    document.body.appendChild(link);
    link.click();
  };

  renderSearchBar = () => {
    return (
      <div className="col-xs-12 col-sm-12 col-md-3 col-lg-4 tableSearchArea">
        <div className="inner-addon right-addon">
          <span className="iconmford fo-icon-search"></span>
          <input
            type="text"
            name="tableSearch"
            id="tableSearch"
            className="form-control"
            placeholder={i18next.t("10053")}
            onChange={(e) => this.handleFilter(e)}
            value={this.state.filterTerm}
          />
        </div>
      </div>
    );
  };

  renderHeaderToolbar = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginRight: "20px",
          marginLeft: "20px",
        }}
      >
        {this.renderSearchBar()}

        <Pagination
          hideFirstLastPages={true}
          prevPageText={i18next.t(10110)}
          nextPageText={i18next.t(10111)}
          hideDisabled={true}
          hideNavigation={true}
          activePage={this.state.activePage}
          itemsCountPerPage={this.settings.itemsPerPage}
          totalItemsCount={
            this.state.filteredTrainingsData?.length > 0
              ? this.state.filteredTrainingsData.length
              : 0
          }
          onChange={(e) => this.handlePageChange(e)}
          itemClass="page-item"
          linkClass="page-link"
        />
      </div>
    );
  };

  renderFooterToolbar = () => {
    return (
      <div className="table-footer-toolbar">
        <button className="export-button" onClick={this.handleExport}>
          <Trans desc="Dışa Aktar">10113</Trans>
        </button>
      </div>
    );
  };

  trType = "";
  trTraining = "";
  trEmployee = "";
  trLocation = "";
  trDepartment = "";
  trPosition = "";
  trStartdate = "";
  trEnddate = "";

  reOrder = (orderBy) => {
    let sort_dir = "asc";
    if (this.state.sort_dir === "asc") sort_dir = "desc";
    this.setState({
      sort_by: orderBy,
      sort_dir: sort_dir,
    });
  };

  setSotingClassNames = () => {
    this.trType = "";
    this.trTraining = "";
    this.trEmployee = "";
    this.trDepartment = "";
    this.trPosition = "";
    this.trLocation = "";
    this.trStartdate = "";
    this.trEnddate = "";

    switch (this.state.sort_by) {
      case "trType":
        this.trType = `_${this.state.sort_dir}`;
        break;
      case "trTraining":
        this.trTraining = `_${this.state.sort_dir}`;
        break;
      case "trEmployee":
        this.trEmployee = `_${this.state.sort_dir}`;
        break;
      case "trLocation":
        this.trLocation = `_${this.state.sort_dir}`;
        break;
      case "trStartdate":
        this.trStartdate = `_${this.state.sort_dir}`;
        break;
      case "trEnddate":
        this.trEnddate = `_${this.state.sort_dir}`;
        break;
      case "trDepartment":
        this.trDepartment = `_${this.state.sort_dir}`;
        break;
      case "trPosition":
        this.trPosition = `_${this.state.sort_dir}`;
        break;
      default:
        this.trTraining = `_${this.state.sort_dir}`;
        break;
    }
  };

  renderData = (start, end) => {
    const sorted = this.state.filteredTrainingsData.sort((a, b) => {
      switch (this.state.sort_by) {
        case "trType":
          return this.state.sort_dir === "desc"
            ? a.trainingMethod?.label.localeCompare(b.trainingMethod?.label)
            : b.trainingMethod?.label.localeCompare(a.trainingMethod?.label);
        case "trTraining":
          return this.state.sort_dir === "desc"
            ? a.training?.name.localeCompare(b.training?.name)
            : b.training?.name.localeCompare(a.training?.name);
        case "trEmployee":
          return this.state.sort_dir === "desc"
            ? a.employee?.name.localeCompare(b.employee?.name)
            : b.employee?.name.localeCompare(a.employee?.name);
        case "trLocation":
          return this.state.sort_dir === "desc"
            ? a.trainingLocation.localeCompare(b.trainingLocation)
            : b.trainingLocation.localeCompare(a.trainingLocation);
        case "trStartdate":
          return this.state.sort_dir === "desc"
            ? new Date(a.startDate) - new Date(b.startDate)
            : new Date(b.startDate) - new Date(a.startDate);
        case "trEnddate":
          return this.state.sort_dir === "desc"
            ? new Date(a.endDate) - new Date(b.endDate)
            : new Date(b.endDate) - new Date(a.endDate);
        case "trDepartment":
          return this.state.sort_dir === "desc"
            ? a.department?.name.localeCompare(b.department?.name)
            : b.department?.name.localeCompare(a.department?.name);
        case "trPosition":
          return this.state.sort_dir === "desc"
            ? a.position?.name.localeCompare(b.position?.name)
            : b.position?.name.localeCompare(a.position?.name);
        default:
          return this.state.sort_dir === "desc"
            ? a.training?.name.localeCompare(b.training?.name)
            : b.training?.name.localeCompare(a.training?.name);
      }
    });

    return sorted.slice(start, end).map((t) => {
      return <RegisteredEmployee key={t.key} t={t} />;
    });
  };

  render() {
    let start = this.settings.itemsPerPage * (this.state.activePage - 1);
    let end = start + this.settings.itemsPerPage;

    this.setSotingClassNames();

    return (
      <>
        {this.props.spinner}
        <div>{this.renderHeaderToolbar()}</div>
        <div
          className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
          id="kayitliEgitimler"
          style={{ display: "block" }}
        >
          <table
            className="table display responsive dataTable no-footer dtr-none collapsed"
            id="dataTablePersonel"
          >
            <thead>
              <tr>
                <th
                  onClick={() => this.reOrder("trType")}
                  className={`all sorting${this.trType}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Tür">10114</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trEmployee")}
                  className={`desktop sorting${this.trEmployee}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Çalışan">10070</Trans>
                  </div>
                </th>
                <DesktopBreakpoint>
                  <th
                    onClick={() => this.reOrder("trTraining")}
                    className={`all sorting${this.trTraining}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Eğitim Adı">10115</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trDepartment")}
                    className={`desktop sorting${this.trDepartment}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Departman">10528</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trPosition")}
                    className={`desktop sorting${this.trPosition}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Pozisyon">10064</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trLocation")}
                    className={`desktop sorting${this.trLocation}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Yer">10016</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trStartdate")}
                    className={`desktop sorting${this.trStartdate}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Başlangıç">10020</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trEnddate")}
                    className={`desktop sorting${this.trEnddate}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Bitiş">10021</Trans>
                    </div>
                  </th>
                </DesktopBreakpoint>
              </tr>
            </thead>
            <tbody>{this.renderData(start, end)}</tbody>
          </table>
        </div>
        <div>
          <hr />
          {this.renderFooterToolbar()}
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ application }) => {
  return {
    application,
  };
};

export default connect(mapStateToProps, { allRegisteredTrainingsExport })(
  containsLongRunningProcess(requireAuth(RegisteredEmployees))
);
